import { FC, useEffect, useState } from 'react'

import Link from 'next/link'

import { mediaQueryUp } from '~/theme/utils/grid'

import { CarouselProvider } from '~/shared/molecules/Carousel'
import { CarouselApi } from '~/shared/molecules/Carousel/CarouselApi'
import { findTabIndex } from '~/shared/molecules/ScrollableTabs/ScrollableTabsUtils'

import { CarouselButton, ScrollableTab, ScrollableTabWrapper, StyledCarouselContent, StyledCarouselItem } from './ScrollableTabsShards'
import { ScrollableTabsProps } from './ScrollableTabsTypes'

const ScrollableTabs: FC<ScrollableTabsProps> = props => {
  const [activeTab, setActiveTab] = useState(props.activeTab)
  const [api, setApi] = useState<CarouselApi>()

  useEffect(() => {
    const timer = setTimeout(() => {
      setActiveTab(() => props.activeTab)
      if (!props.activeTab) return

      api?.scrollTo(findTabIndex(props.activeTab, props.tabs))
    }, 100)

    return () => clearTimeout(timer)
  }, [api, props.activeTab, props.tabs])

  return (
    <ScrollableTabWrapper>
      <CarouselProvider
        setApi={setApi}
        autoPlay={false}
        autoplayOptions={{ active: false }}
        options={{ skipSnaps: true, slidesToScroll: 'auto', breakpoints: { [mediaQueryUp('m')]: { watchDrag: false } } }}>
        <StyledCarouselContent>
          {props.tabs.map(tab => (
            <StyledCarouselItem key={tab.id}>
              <Link href={tab.hash} passHref>
                <ScrollableTab isActive={activeTab === tab.id}>{tab.label}</ScrollableTab>
              </Link>
            </StyledCarouselItem>
          ))}
        </StyledCarouselContent>
        <CarouselButton />
        <CarouselButton isNext />
      </CarouselProvider>
    </ScrollableTabWrapper>
  )
}

export default ScrollableTabs
